/**
 * drawer-action-button.js
 */

import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from 'components/button';
import { shouldRenderMobileLayout } from 'utils/app-context';
import clsx from 'clsx';


const useStyles = makeStyles(theme => ({
  mobile: {
    color: theme.palette.sys.onPrimary,
    fontSize: theme.typography.sizes[3],
    fontWeight: theme.typography.fontWeightRegular,
    minWidth: theme.spacing(6),
    '&.Mui-disabled': {
      color: theme.palette.comp.appBar.button.disabled,
    },
  },
}));


export default function DrawerActionButton(props) {
  const btnProps = {...props};
  const classes = useStyles();
  btnProps.level = shouldRenderMobileLayout() ? 3 : btnProps.level;
  btnProps.upperCase = false;

  return (
    <Button
      className={clsx({
        [classes.mobile] : shouldRenderMobileLayout(),
      })}
      {...btnProps}
    >
      {btnProps.children}
    </Button>
  );
}

